import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  ViewEncapsulation
} from '@angular/core';
import { RadioComponent, TD_WB_RADIO } from '../radio/radio.component';

@Component({
  selector: 'td-wb-toggle-label-item',
  templateUrl: 'toggle-label-item.component.html',
  styleUrls: ['toggle-label-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.td-wb-toggle-label-item--checked]': 'checked()',
    '[class.td-wb-toggle-label-item--disabled]': 'disabled()'
  },
  providers: [
    { provide: TD_WB_RADIO, useExisting: forwardRef(() => ToggleLabelItemComponent) }
  ]
})

export class ToggleLabelItemComponent extends RadioComponent {
}
